/**
 * 微信检测工具
 */

export const isWeiXin = (): boolean => /MicroMessenger/i.test(navigator.userAgent);